import { generateResourceReducer } from '../generators/resource.reducer';
import * as types from './project-report.types';
import * as constants from './project-report.constants';

export const projectReportReducer = generateResourceReducer<types.IProjectReport>({
  STORE: constants.STORE_PROJECT_REPORT,
  CLEAR: constants.CLEAR_PROJECT_REPORT,
});
